export const LevelsOfAssurance = Object.freeze({
  AnyAccount: 0,
  SocialAccount: 1,
  VerifiedExternal: 2,
  HEPTrusted: 3,
  EduGainWithSIRTIFI: 4,
  CERN: 5,
});
